import { render } from "./DistributorList.vue?vue&type=template&id=712b4c0c&scoped=true"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"

import "./DistributorList.vue?vue&type=style&index=0&id=712b4c0c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-712b4c0c"

export default script